// import { router } from '@/utils';

// 路由表
export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home'),
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/index'),
      },
      {
        path: 'case',
        name: 'case',
        component: () => import('@/views/case'),
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/about'),
      },
    ]
  }
];
